import { TabbedView } from './TabbedView';
export default TabbedView;
